import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Creme = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.2 82.95">
  <G fill={color}>
    <Path d="M31.3,67.4l2.89-44.19c.05-.83-.24-1.65-.82-2.26l-7.39-7.8-2.44-10.8c-.31-1.37-1.53-2.34-2.93-2.34h-7.04c-1.4,0-2.62.97-2.93,2.34l-2.43,10.8L.82,20.95C.25,21.56-.05,22.37,0,23.21l2.89,44.21c-1.28.34-2.23,1.5-2.23,2.89v9.63c0,1.66,1.34,3,3,3h26.94c1.66,0,3-1.34,3-3v-9.63c0-1.42-.99-2.6-2.32-2.92ZM10.24,34.04c0-1.66,1.34-3,3-3h7.11c1.66,0,3,1.34,3,3v18.02c0,1.66-1.34,3-3,3h-7.11c-1.66,0-3-1.34-3-3v-18.02ZM15.98,6.01h2.24l1.26,5.6h-4.77l1.26-5.6ZM27.61,76.94H6.67v-3.63h20.94v3.63Z"/>
  </G>
</Svg>
);
};

export default Creme;
